// extracted by mini-css-extract-plugin
export var externalLink = "_dj-0";
export var internalLinkLabel = "_dj-1";